export const enum RowPropertiesEnum {
    RowCategory="rowCategory",
    SeatsQuantity="seatsQuantity",
    SeatsCurve="seatsCurve",
    SeatsSpacing="seatsSpacing",
    SeatLabeling="seatLabeling",
    StartsAt="startsAt",
    Reverse="reverse",
    SectionLabel="sectionLabel",
    DisplayedSectionLabel="displayedSectionLabel",
    EnabledRowLabel="enabledRowLabel",
    RowLabel="rowLabel",
    DisplayedRowLabel="displayedRowLabel",
    LabelPositionLeft="labelPositionLeft",
    LabelPositionRight="labelPositionRight",
    SeatCategory="seatCategory",
    SeatLabel="seatLabel",
    DisplayedSeatLabel="displayedSeatLabel",
    RestrictedView="restrictedView",
    Accesible="accesible",
    Companion="companion",
}